import { render } from "./Navbar.vue?vue&type=template&id=1e64d0fc&lang=pug"
import script from "./Navbar.vue?vue&type=script&lang=ts"
export * from "./Navbar.vue?vue&type=script&lang=ts"

import "./Navbar.vue?vue&type=style&index=0&id=1e64d0fc&lang=scss"
script.render = render

export default script